import createHistory from 'history/createBrowserHistory';

let onHistoryBlockedCallback = null;
let unblockHistoryFunction = null;

/**
 * Sets a callback to the list to be called when history is blocked.
 * Remember to `unblockHistory()` when done.
 *
 * @param {string} message The message to pass to the callback/display.
 * @param {Function} callback Default is `window.confirm`
 *    Of the form: `(message) => { return confirmedBool; }`
 *    Returns a `boolean` to pass to internal callback.
 *    callback(true) to continue the transition, or
 *    callback(false) to abort it.
 * @throws Error If the callback isn't a function.
 * @see unblockHistory()
 */
export const blockHistory = (message, callback = window.confirm) => {
  if (typeof callback !== 'function') {
    throw new Error('Callback must be a function');
  }
  // We don't allow for more than one blocker by design.
  unblockHistory();
  onHistoryBlockedCallback = callback;
  unblockHistoryFunction = history.block(message);
};

/**
 * Unblocks history.
 * @see blockHistory()
 */
export const unblockHistory = () => {
  onHistoryBlockedCallback = null;
  if (unblockHistoryFunction) {
    unblockHistoryFunction();
    unblockHistoryFunction = null;
  }
};

// See: https://github.com/ReactTraining/history/blob/master/docs/Blocking.md
const history = createHistory({
  getUserConfirmation(message, callback) {
    // callback(true) to continue the transition.
    // However, callback(false) results in a weird middle page, so not using that.
    const isNavigateAway = onHistoryBlockedCallback(message);
    return isNavigateAway ? callback(true) : lastHistoryLocation;
  }
});

let lastHistoryLocation;
history.listen((location) => {
  lastHistoryLocation = location.pathname;
  window.scrollTo(0, 0);
});

export default history;



// WEBPACK FOOTER //
// ./src/lib/history.js